import "./ClientPieChart.css";
import Charts from "./Charts";
import { useEffect, useState } from "react";
import * as echarts from "echarts";
import Url from "../../Services/Url";
import { PublicGet } from "../../Services/Server";
import User from "../../Services/User";

const BarChart = ({ chartId, op, dashboardType = "maritime" }) => {
	const companyId = User.getCompany().id;

	const currentDate = new Date();
	const [filterYear, setFilterYear] = useState(currentDate.getFullYear());
	const [filterMonth, setFilterMonth] = useState(currentDate.getMonth() + 1);
	const [filteredData, setFilteredData] = useState([]);
	const [chartInstance, setChartInstance] = useState(null);

	// Initialize chart once
	useEffect(() => {
		const chartDom = document.getElementById(chartId);
		if (chartDom && !chartInstance) {
			setChartInstance(echarts.init(chartDom));
		}
	}, [chartId, chartInstance]);

	const buildUrl = (companyId, month, year) => {
		return dashboardType === "enterprise"
			? Url.public.getEntCompanyTaskByState(companyId, year, month)
			: Url.public.getMrtCompanyTaskByVessel(companyId, year, month);
	};

	//  Fetch data whenever filters or dashboardType change
	useEffect(() => {
		const url = buildUrl(companyId, filterMonth, filterYear);

		PublicGet(url)
			.then((response) => {
				console.log(response);

				const fetchedData = response?.content || response || [];
				// Set the data, regardless of whether it's empty or not
				setFilteredData(fetchedData);
			})
			.catch((error) => {
				console.error("Error fetching bar chart data:", error);
				// On error, clear data to clear chart
				setFilteredData([]);
			});
	}, [filterMonth, filterYear, companyId, dashboardType]);

	const xdata =
		dashboardType === "enterprise"
			? filteredData.map((v) => v.stateName || "") // Use stateName for enterprise
			: filteredData.map((v) => v.vesselName || ""); // Use vesselName for maritime

	const getData = () =>
		filteredData.map((v) => ({
			value: v.taskCount,
			name: dashboardType === "enterprise" ? v.stateName : v.vesselName,
			itemStyle: { color: "#14B8FF" },
		}));

	useEffect(() => {
		if (!chartInstance) return;

		if (filteredData.length === 0) {
			const emptyOptions = {
				xAxis: { type: "category", data: [] },
				yAxis: { type: "value" },
				series: [{ data: [], type: "bar" }],
				graphic: {
					elements: [
						{
							type: "text",
							left: "center",
							top: "middle",
							style: {
								text: "No Data Available",
								fill: "#888",
								font: "20px sans-serif",
							},
						},
					],
				},
			};
			chartInstance.setOption(emptyOptions, true); // Use true for `notMerge` to fully overwrite
		} else {
			const seriesData = getData();
			const chartOptions = Charts.getBar
				? Charts.getBar(seriesData, xdata)
				: {
						title: { text: "Jobs Overview", left: "center" },
						xAxis: { type: "category", data: xdata },
						yAxis: { type: "value" },
						series: [
							{
								data: seriesData.map((d) => d.value),
								type: "bar",
								itemStyle: { color: "#14B8FF" },
							},
						],
						graphic: { elements: [] },
				  };
			chartInstance.setOption(chartOptions, true); // Use true for `notMerge` to fully overwrite
		}
	}, [chartInstance, filteredData, dashboardType]); // Added dashboardType to dependency array

	
	const handleYearChange = (e) => setFilterYear(Number(e.target.value));
	const handleMonthChange = (e) => setFilterMonth(Number(e.target.value));

	const currentYear = currentDate.getFullYear();
	const yearOptions = Array.from(
		{ length: currentYear - 2022 },
		(_, i) => 2023 + i
	);
	const monthNames = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];

	return (
		<div style={{ width: "100%" }} className="PieChart">
			<div className="PieHead">
				<h4>Jobs Overview</h4>
				<div className="filter-controls">
					<select value={filterMonth} onChange={handleMonthChange}>
						{monthNames.map((m, i) => (
							<option key={m} value={i + 1}>
								{m}
							</option>
						))}
					</select>
					<select value={filterYear} onChange={handleYearChange}>
						{yearOptions.map((y) => (
							<option key={y} value={y}>
								{y}
							</option>
						))}
					</select>
				</div>
			</div>

			<div id={chartId} style={{ width: "100%", height: "500px" }}></div>
		</div>
	);
};

BarChart.defaultProps = {
	chartId: "BarChart",
};

export default BarChart;
